import { defineMessages } from 'react-intl';
import configs from "configs"

export const scope = 'app.containers.Quotation';

export default defineMessages({
  step1_title: {
    id: `${scope}.step1_title`,
    defaultMessage: 'Dati personali',
  },
  step1_title_short: {
    id: `${scope}.step1_title_short`,
    defaultMessage: 'Anagrafica',
  },
  step2_title: {
    id: `${scope}.step2_title`,
    defaultMessage: 'Conferma dati',
  },
  step2_title_short: {
    id: `${scope}.step2_title_short`,
    defaultMessage: 'Conferma',
  },
  step3_title: {
    id: `${scope}.step3_title`,
    defaultMessage: 'Sostenibilità',
  },
  step3_title_short: {
    id: `${scope}.step3_title_short`,
    defaultMessage: 'Sostenibilità',
  },
  step4_title: {
    id: `${scope}.step4_title`,
    defaultMessage: 'Carica documenti',
  },
  step4_title_short: {
    id: `${scope}.step4_title_short`,
    defaultMessage: 'Documenti',
  },
  step5_title: {
    id: `${scope}.step5_title`,
    defaultMessage: 'Stato pratica',
  },
  step5_result_info: {
    id: `${scope}.step5_result_info`,
    defaultMessage: 'In lavorazione',
  },
  step5_result_info_description: {
    id: `${scope}.step5_result_info_description`,
    defaultMessage: 'La tua richiesta è stata ricevuta ed è al momento in fase di elaborazione',
  },
  step5_result_won: {
    id: `${scope}.step5_result_won`,
    defaultMessage: 'Richiesta approvata',
  },
  step5_result_won_description: {
    id: `${scope}.step5_result_won_description`,
    defaultMessage: 'La tua richiesta è stata approvata',
  },
  step5_result_lost: {
    id: `${scope}.step5_result_lost`,
    defaultMessage: 'Richiesta respinta',
  },
  step5_result_lost_description: {
    id: `${scope}.step5_result_lost_description`,
    defaultMessage: 'La tua richiesta è stata respinta',
  },
  btnSetToLost: {
    id: `${scope}.btnSetToLost`,
    defaultMessage: 'Rifiuta preventivo',
  },
  btnSetToWon: {
    id: `${scope}.btnSetToWon`,
    defaultMessage: 'Accetta preventivo',
  },
  back: {
    id: `${scope}.back`,
    defaultMessage: 'Indietro',
  },
  expiredOffer: {
    id: `${scope}.expiredOffer`,
    defaultMessage: configs.messages[scope].expiredOffer,
  },
});
